export default __webpack_public_path__ + "static/media/3.c1a4fc59.png";